import React from 'react';
import MessageList from './MessageList'; // Assuming MessageList is in the same directory
import { ChatInput } from './ChatInput';   // Assuming ChatInput is in the same directory
import { useUIStore } from '../../store/uiStore'; 
// No longer need useChatStore here for setChatViewMode
// import { useChatStore } from '../../store/chatStore'; 
import styles from './ChatSidebarView.module.css'; // Import the CSS module
import WidgetHeader from '../common/WidgetHeader'; // Import the new WidgetHeader
// import { ExpandIcon, MinimizeIcon, CloseIcon, MenuIcon } from '../common/Icons'; // Import icons
// import { useUIStore } from '../../store/uiStore'; // Placeholder for UI store
import useAuthStore from '../../store/authStore'; // Removed UserStatus import
import LoadingIndicator from '../common/LoadingIndicator'; // Import LoadingIndicator
import ConversationHistory from './ConversationHistory'; // <--- Import ConversationHistory
import useMediaQuery from '../../hooks/useMediaQuery'; // <--- Import useMediaQuery

// No props needed for this component currently
// interface ChatSidebarViewProps {
//   // Props like isVisible, onClose, onExpand, etc.
// }

const ChatSidebarView: React.FC = () => { // Removed ChatSidebarViewProps
  // Get actions and state from the new uiStore
  const {
    chatViewMode, // Need to read the current view mode
    isHistoryPanelVisibleOnMobile,
    closeChatToBubble,
    openChatToFullscreen,
    minimizeChatToSidebar,
    toggleHistoryPanelVisibility,
    isInitializingChat, // Get the new state from uiStore
  } = useUIStore();

  const { userStatus, messageLimits, apiUrls, isLoadingInitialData } = useAuthStore();

  // Remove setChatViewMode from chatStore
  // const setChatViewMode = useChatStore((state) => state.setChatViewMode);

  const handleClose = () => {
    console.log('Close button clicked. Closing to bubble view via uiStore.');
    closeChatToBubble();
  };

  const handleExpandOrMinimize = () => {
    console.log(`Expand/Minimize button clicked. Currently chatViewMode: ${chatViewMode}. Toggling via uiStore.`);
    if (chatViewMode === 'fullscreen') {
      minimizeChatToSidebar();
    } else if (chatViewMode === 'sidebar') {
      openChatToFullscreen();
    }
  };

  const handleToggleHistoryPanel = () => {
    console.log('Menu icon clicked, toggling history panel visibility on mobile via uiStore.');
    toggleHistoryPanelVisibility();
  };

  // Placeholder data for UI elements - will be replaced by Zustand state
  // To test different states, change userStatusPlaceholder and messagesRemainingPlaceholder:
  // 1. Guest, messages available: userStatusPlaceholder = 'guest', messagesRemainingPlaceholder = 5
  // 2. Guest, limit reached: userStatusPlaceholder = 'guest', messagesRemainingPlaceholder = 0
  // 3. Basic user, messages available: userStatusPlaceholder = 'loggedin_basic', messagesRemainingPlaceholder = 5
  // 4. Basic user, limit reached: userStatusPlaceholder = 'loggedin_basic', messagesRemainingPlaceholder = 0
  // 5. Premium user: userStatusPlaceholder = 'loggedin_premium', messagesRemainingPlaceholder = 50 (limit not shown for premium)

  const isGuestLimitReached = userStatus === 'guest' && (messageLimits?.max !== null && messageLimits?.max !== undefined && messageLimits?.current !== null && messageLimits?.current >= messageLimits.max);
  const isBasicUserLimitReached = userStatus === 'loggedin_basic' && (messageLimits?.max !== null && messageLimits?.max !== undefined && messageLimits?.current !== null && messageLimits?.current >= messageLimits.max);

  const loginUrl = apiUrls?.loginUrl || '/wp-login.php'; // Default fallback
  const upgradeUrl = apiUrls?.upgradeUrl || '/grupuri/plus/'; // Default fallback

  // Use isLoadingInitialData from authStore as the primary signal for the initial data fetch, 
  // isInitializingChat from uiStore can be a more general flag if needed for other UI initializing states.
  // For this specific purpose, isLoadingInitialData is more direct from the data fetching process itself.
  const showLoadingState = isLoadingInitialData || isInitializingChat;

  const isMobile = useMediaQuery('(max-width: 768px)'); // <--- Add isMobile check

  return (
    <div className={styles.sidebarViewContainer}>
      <WidgetHeader
        brandText="Smartie"
        chatViewMode={chatViewMode}
        isHistoryPanelVisibleOnMobile={isHistoryPanelVisibleOnMobile}
        onClose={handleClose}
        onExpandOrMinimize={handleExpandOrMinimize}
        onToggleHistoryPanel={handleToggleHistoryPanel}
      />

      {/* Conditional rendering for ConversationHistory as overlay on mobile sidebar */}
      {isMobile && chatViewMode === 'sidebar' && isHistoryPanelVisibleOnMobile && (
        <ConversationHistory overlayMode="sidebarMobile" />
      )}

      {showLoadingState ? (
        <div className={styles.loadingContainer}>
          <LoadingIndicator text="Se inițializează..." />
        </div>
      ) : (
        <>
          <div className={styles.conversationArea}>
            {/* Initial Greeting - conditionally rendered if no messages or based on a flag */}
            {/* For now, MessageList will handle empty state if applicable */}
            {/* Consider adding an explicit greeting if MessageList is empty later */}
            {/* <p style={{ textAlign: 'center', color: '#666', marginTop: '20px' }}>Salutări, sunt Smartie...</p> */}
            <MessageList />
          </div>

          {isGuestLimitReached ? (
            <div className={styles.limitReachedMessage}>
              <p>Autentifică-te pentru a putea trimite mai multe mesaje.</p>
              <a href={loginUrl} className={styles.actionButton}>Autentificare</a> 
            </div>
          ) : isBasicUserLimitReached ? (
            <div className={styles.limitReachedMessage}>
              <p>Devino membru SMARTERS+ pentru a continua conversația și pentru funcționalități mai puternice.</p>
              <a href={upgradeUrl} className={styles.actionButton}>Devino SMARTERS+</a> 
            </div>
          ) : (
            // This div acts as a container for ChatInput and the footer, ensuring footer is below input
            <div className={styles.inputAndFooterContainer}>
              <ChatInput />
              {/* {userStatus !== 'loggedin_premium' && messageLimits && (
                <footer className={styles.footerInfo}>
                  <span>{messageLimits.current}/{messageLimits.max ?? '∞'} mesaje rămase</span> | <span>Status: {getUserStatusDisplay(userStatus)}</span>
                </footer>
              )} */}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ChatSidebarView; 